module.exports = __webpack_public_path__ + "static/media/kaguya2.fbbbd89d.png";